import React from 'react';
import { connect } from 'react-redux';

import classes from './Content.scss';

const content = (props) => {
    return (
        <div className={`${classes.Content} u-relative u-width100Percent f-fill`}
        style={{ paddingRight: props.slideContent && window.innerWidth > 1200 ? '36rem' : '0' }}>
            {props.children}
        </div>
    );
}

const mapStateToProps = state => {
    return {
      slideContent: state.roundTripSummary.sidebar,
    }
  }

export default connect(mapStateToProps)(content);


// WEBPACK FOOTER //
// ./src/containers/Content/Content.js